import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, keywords, type = 'website', image, url }) {
  const siteUrl = 'https://epiphoric.com';
  // Ensure URL is absolute for social platforms
  const currentUrl = url 
    ? (url.startsWith('http') ? url : `${siteUrl}${url}`)
    : window.location.href;
  const defaultImage = `${siteUrl}/epiphoric-wide.png`;
  
  // Ensure image is an absolute URL for social platforms
  const metaImage = image 
    ? (image.startsWith('http') ? image : `${siteUrl}${image}`) 
    : defaultImage;

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{title} | Epiphoric</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:site_name" content="Epiphoric" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
}

